export default __webpack_public_path__ + "static/layout-do-dark-b39d7b2552de3249ec457a55cf4e4cded140d211308bf4cbaf6a22e4dc8817f4.png";